import { __decorate } from "tslib";
import { theme } from '@dojo/framework/core/mixins/Themed';
import { v, w } from '@dojo/framework/core/vdom';
import { Button } from '@dojo/widgets/button';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import has from '@dojo/framework/core/has';
import { assessmentScore, guidedtourChange, whichActiveView } from '@holmescorp/lcc-state';
import { logQuiz } from '@holmescorp/logger';
import { numeral } from '@holmescorp/numeral';
import { publish } from '@holmescorp/pub-sub';
import { ScoreChart } from '@holmescorp/progress-chart';
import { convertToBoolean } from '@holmescorp/common';
import css from '../../css/questionfeedback.m.css';
import { QuestionQueue } from '../../support/questionqueue';
import { ScoreRollup } from '../../support/score-rollup';
import { setInreview, setIsaudit } from '../../support/state';
import { QFAuditBase } from './auditbase';
import { Countdown } from '../../support/countdown-timer';
import { CountdownTimer } from '../../widgets/countdown-timer';
const isEmpty = (obj) => Object.keys(obj).length === 0;
let PretestQuestionFeedback = class PretestQuestionFeedback extends QFAuditBase {
    countdown = null;
    onDetach() {
        this.countdown && this.countdown.stop();
        this.countdown = null;
    }
    run_quiz_end() {
        const { info } = this.properties;
        const lastresult = info && info.lastresult;
        const hasLastresult = lastresult && !isEmpty(lastresult);
        const percent = hasLastresult ? lastresult.totalpercentcorrect * 0.01 : 0;
        assessmentScore({ score: `${numeral(percent).format('0%')}` });
        return [];
    }
    buttons() {
        const { quiz = {}, quizstore, info, isrunning, quizid, theme, localizedBundle: { messages: { continue: continueText = 'Continue', start_over: restartText = 'Start Over', begin: beginText = 'Begin', review_last_attempt: reviewText = '', hide_begin_on_quiz_end = 'none', show_pretest_timer = 'true' } } } = this.properties;
        const { use_restart } = quiz;
        const { svc } = this;
        const noBeginOnFinal = isrunning === 'final' && hide_begin_on_quiz_end !== 'none';
        const showTimer = convertToBoolean(show_pretest_timer);
        if (use_restart) {
            if (this.countdown === null) {
                const { countdowntime } = info;
                this.countdown = new Countdown(countdowntime, quizstore);
            }
            this.countdown && this.countdown.start();
            return [
                v('div', { xqa: 'action continue', classes: [this.theme(css.oneaction)] }, [
                    w(Button, {
                        theme,
                        key: 'continue',
                        onClick: () => {
                            if (!this._inAction) {
                                this._inAction = true;
                                logQuiz.info(`continue quiz ${quizid}`);
                                setIsaudit(quizstore)({ isaudit: false });
                                setInreview(quizstore)({ inreview: false });
                                svc.continue_quiz().then((v) => {
                                    this.startquiz = v;
                                    this.quiz_startup();
                                });
                            }
                        }
                    }, [continueText])
                ]),
                v('div', { key: `restart-block`, xqa: 'action restart', classes: [this.theme(css.oneaction)] }, [
                    w(Button, {
                        theme,
                        key: 'restart',
                        onClick: () => {
                            if (!this._inAction) {
                                this._inAction = true;
                                logQuiz.info(`restart quiz ${quizid}`);
                                this.countdown && this.countdown.stop();
                                this.countdown = null;
                                setIsaudit(quizstore)({ isaudit: false });
                                setInreview(quizstore)({ inreview: false });
                                svc.restart_quiz().then((v) => {
                                    this.startquiz = v;
                                    this.quiz_startup(true);
                                });
                            }
                        }
                    }, [restartText])
                ]),
                showTimer
                    ? v('div', { key: 'timer', classes: [this.theme(css.timerblock)] }, [
                        v('div', { classes: [this.theme(css.timer)] }, [
                            w(CountdownTimer, { quizstore, countdown: '' })
                        ])
                    ])
                    : null
            ];
        }
        else {
            const lastresult = info && info.lastresult;
            const hasLastresult = lastresult && !isEmpty(lastresult);
            return [
                v('div', { key: `begin-block`, xqa: 'action begin', classes: [this.theme(css.oneaction)] }, [
                    noBeginOnFinal
                        ? null
                        : w(Button, {
                            theme,
                            key: 'begin',
                            onClick: () => {
                                if (!this._inAction) {
                                    this._inAction = true;
                                    logQuiz.info(`begin quiz ${quizid}`);
                                    this.countdown && this.countdown.stop();
                                    this.countdown = null;
                                    setIsaudit(quizstore)({ isaudit: false });
                                    setInreview(quizstore)({ inreview: false });
                                    svc.start_quiz().then((v) => {
                                        this.startquiz = v;
                                        this.quiz_startup();
                                    });
                                }
                            }
                        }, [beginText])
                ]),
                hasLastresult && !quiz.attempts_noaudit
                    ? w(Button, {
                        theme,
                        key: 'audit',
                        onClick: () => {
                            if (!this._inAction) {
                                this._inAction = true;
                                this.audit_init();
                                const { auditsvc } = this;
                                logQuiz.info(`audit quiz ${quizid}`);
                                setIsaudit(quizstore)({ isaudit: true });
                                setInreview(quizstore)({ inreview: false });
                                auditsvc.start_quiz().then(() => {
                                    this.startquiz = { cursor: 0, status: 'feedback' };
                                    this.audit_startup();
                                });
                            }
                        }
                    }, [reviewText])
                    : null
            ];
        }
    }
    render_micro_view() {
        const { quiz = {}, info, isrunning, quizid, quizstore, theme, localizedBundle: { messages: { continue: continueText = '', takePretestText = 'Take Pre-test', review_last_attempt: reviewText = '', revisit: revisitText = '', hide_begin_on_quiz_end = 'none', final_test_score_label = 'Best Test Score' } } } = this.properties;
        const { svc } = this;
        const { use_restart } = quiz;
        const lastresult = info && info.lastresult;
        const hasLastresult = lastresult && !isEmpty(lastresult);
        const { instructions_done, instructions } = quiz;
        const noBeginOnFinal = isrunning === 'final' && hide_begin_on_quiz_end !== 'none';
        const bestScore = parseInt(info?.bestscore || '-1');
        const passingScore = parseFloat(quiz?.passingscore) || 80;
        const lastScore = hasLastresult ? lastresult.totalpercentcorrect : 0;
        const hasPassed = hasLastresult ? lastScore >= passingScore : false;
        const getHomeOrBackButton = (isHome) => v('div', {
            xqa: 'action home',
            classes: [this.theme(css.oneaction), isHome ? this.theme(css.primaryButton) : null]
        }, [
            w(Button, {
                theme,
                key: 'home',
                onClick: () => {
                    publish(`site/homepage`);
                }
            }, [
                isHome
                    ? v('span', {}, [
                        v('i', {
                            classes: ['fas', 'fa-home', this.theme(css.actionIcon)]
                        }),
                        'Home'
                    ])
                    : v('span', {}, [
                        v('i', {
                            classes: ['fas', 'fa-arrow-left', this.theme(css.actionIcon)]
                        }),
                        'Go Back'
                    ])
            ])
        ]);
        const continue_button = v('div', {
            xqa: 'action continue',
            classes: [this.theme(css.oneaction), this.theme(css.primaryButton)]
        }, [
            w(Button, {
                theme,
                key: 'continue',
                onClick: () => {
                    if (!this._inAction) {
                        this._inAction = true;
                        logQuiz.info(`continue quiz ${quizid}`);
                        setInreview(quizstore)({ inreview: false });
                        svc.continue_quiz().then((v) => {
                            this.startquiz = v;
                            this.quiz_startup();
                        });
                    }
                }
            }, [continueText])
        ]);
        const begin_button = v('div', {
            xqa: 'action begin',
            classes: [this.theme(css.oneaction), !hasPassed ? this.theme(css.primaryButton) : null]
        }, [
            noBeginOnFinal || hasPassed
                ? null
                : w(Button, {
                    theme,
                    key: 'begin',
                    disabled: hasPassed,
                    onClick: () => {
                        if (!this._inAction) {
                            this._inAction = true;
                            logQuiz.info(`begin quiz ${quizid}`);
                            this.countdown && this.countdown.stop();
                            this.countdown = null;
                            setInreview(quizstore)({ inreview: false });
                            svc.start_quiz().then((v) => {
                                this.startquiz = v;
                                this.quiz_startup();
                            });
                        }
                    }
                }, [
                    hasLastresult
                        ? revisitText
                        : v('span', {}, [
                            takePretestText,
                            v('i', {
                                classes: ['fas', 'fa-arrow-right', this.theme(css.actionIcon)]
                            })
                        ])
                ])
        ]);
        const audit_button = v('div', {
            xqa: 'action review',
            classes: [this.theme(css.oneaction), this.theme(css.primaryButton)]
        }, [
            w(Button, {
                theme,
                key: 'audit',
                onClick: () => {
                    if (!this._inAction) {
                        this._inAction = true;
                        this.audit_init();
                        const { auditsvc } = this;
                        logQuiz.info(`audit quiz ${quizid}`);
                        setIsaudit(quizstore)({ isaudit: true });
                        setInreview(quizstore)({ inreview: false });
                        auditsvc.start_quiz().then(() => {
                            this.startquiz = { cursor: 0, status: 'feedback' };
                            this.audit_startup();
                        });
                    }
                }
            }, [reviewText])
        ]);
        const isFirstAttempt = !hasLastresult;
        const isAuditable = hasLastresult && !quiz.attempts_noaudit;
        const instructionText = hasPassed
            ? `${instructions_done}`
            : hasLastresult && !use_restart
                ? instructions_done
                : instructions;
        return [
            v('div', { classes: [this.theme(css.microQuizWrapper)], xqa: 'micro-quiz-wrapper' }, [
                v('div', { classes: [this.theme(css.microQuizHeader)] }, [
                    v('div', {
                        key: 'instructions',
                        id: 'quiz-instructions',
                        classes: [
                            this.theme(css.instructions),
                            hasPassed ? this.theme(css.passed_instructions) : null,
                            'micro-quiz-instructions'
                        ],
                        innerHTML: instructionText
                    }),
                    hasLastresult
                        ? v('div', { key: 'score', classes: [this.theme(css.score)], xqa: 'last-quiz-score' }, [
                            w(ScoreChart, {
                                score: lastresult?.totalpercentcorrect || -1,
                                bestScore,
                                bestScoreText: final_test_score_label,
                                insideLabelText: 'Test Score'
                            })
                        ])
                        : v('div', { key: 'score', xqa: 'last-quiz-score' })
                ]),
                v('div', {
                    key: 'quiz-actions',
                    classes: [this.theme(css.actions)],
                    role: 'group',
                    ...formatAriaProperties({ labelledby: 'quiz-instructions' })
                }, use_restart
                    ? [getHomeOrBackButton(false), continue_button]
                    : [
                        isFirstAttempt || isAuditable ? getHomeOrBackButton(false) : null,
                        noBeginOnFinal || isAuditable ? null : begin_button,
                        isAuditable ? audit_button : null
                    ])
            ])
        ];
    }
    render_page() {
        const { isPlaceholder, messages: { study_after_pretest: studyAfterPretest = false } } = this.properties.localizedBundle;
        if (isPlaceholder) {
            return [];
        }
        const { info, isrunning, instancekey = '', quizstore } = this.properties;
        const callback = () => {
            const nextView = studyAfterPretest ? 'study' : 'assess';
            whichActiveView({ whichActive: nextView });
            publish('site/homepage');
        };
        switch (isrunning) {
            case 'quiz': {
                if (this.countdown === null) {
                    const { countdowntime } = info;
                    this.countdown = new Countdown(countdowntime, quizstore);
                }
                this.countdown && this.countdown.start();
                const { startquiz, svc } = this;
                const finalize = () => {
                    if (this.countdown !== null) {
                        this.countdown.stop();
                        this.countdown = null;
                    }
                    this.finalize();
                };
                return [
                    w(QuestionQueue, {
                        key: `${instancekey}-queue`,
                        svc,
                        finalize,
                        startquiz,
                        quizstore
                    })
                ];
            }
            case 'audit':
                return this.run_audit();
            case 'final':
                this.countdown && this.countdown.stop();
                this.countdown = null;
                guidedtourChange({ guidedtour: true });
                this.run_quiz_end();
                if (has('use-micro-view')) {
                    return this.render_micro_view();
                }
                callback();
                return [];
            default:
                return has('use-micro-view') ? this.render_micro_view() : this.run_quiz_begin();
        }
    }
    render() {
        const { quiz, info, key, quizstore } = this.properties;
        const hasdata = quiz && info;
        !hasdata && this.load_quiz();
        return v('div', { key, xqa: `progression pretest question-feedback` }, hasdata
            ? [w(ScoreRollup, { key: `rollup-${key}`, quizstore }, this.render_page())]
            : this.render_loading());
    }
};
PretestQuestionFeedback = __decorate([
    theme(css)
], PretestQuestionFeedback);
export { PretestQuestionFeedback };
export default PretestQuestionFeedback;
